import { initialState } from "./state"

export default {
  setListOptionsOffers: (state, payload) => (state.listOptionsOffers = payload),
  setRulesOffers: (state, payload) => (state.rulesOffers = payload),

  setOffersSelecteds: (state, payload) => (state.offersSelecteds = payload),
  putOffersSelecteds: (state, payload) => state.offersSelecteds.push(payload),
  deleteOffersSelecteds: (state, indexToRemove) =>
    state.offersSelecteds.splice(indexToRemove, 1),

  resetOffer: state => {
    const init_state = initialState()
    Object.assign(state, init_state)
  },
  setParamsFilter: (state, payload) => (state.paramsFilter = payload),
  setFilterCampaignSelecteds: (state, payload) =>
    (state.filterCampaignSelecteds = payload),
  setFilterCampaignSelectedsToInitial: state =>
    (state.filterCampaignSelecteds = initialState().filterCampaignSelecteds)
}
